export enum ExportResourceEnum {
  t2057_fill_17f = 'pdfs/t2057-fill-17f.pdf'
}
